import React, { useState, useEffect } from "react";
import "./UpdatePassword.css";
import passwordIcon from "../../assets/images/pass_icon.png";
import { Redirect } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../../assets/images/fflogo.svg";
import { useHistory, useLocation } from "react-router-dom";
import userService from "../../services/user.service";
import { toast } from "react-toastify";
import Loader from "../subComponents/Loader";
import OtpInput from "react-otp-input";
import login_ellipse from "../../assets/images/login_ellipse.svg";
import login_triangle from "../../assets/images/login_triangle.svg";
import { ArrowLeft, Copyright } from "lucide-react";
import { t } from "../../locales/translate";
import { Tty } from "@mui/icons-material";

function UpdatePassword() {
  const history = useHistory();
  const initialValues = { otp: "", newPassword: "", confirmPassword: "" };
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [formValues, setFormValues] = useState(initialValues);
  const [newPasswordType, setNewPasswordType] = useState("password");
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (location.state && location.state.email && location.state.otpGenerated) {
      setEmail(location.state.email.trim());
    } else {
      history.push("/");
    }
  }, [location.state, history]);

  const handleChange = (e) => {
    if (e && e.target) {
      const { name, value } = e.target;
      setFormValues({ ...formValues, [name]: value });
    } else {
      setFormValues({ ...formValues, otp: e });
    }

  };
  // useEffect(() => {
  //   validate(formValues);
  //   setFormErrors({});
  // }, [formValues]);

  const toggleConfirmPassword = () => {
    setConfirmPasswordType((prevType) =>
      prevType === "password" ? "text" : "password"
    );
  };
  const toggleNewPassword = () => {
    setNewPasswordType((prevType) =>
      prevType === "password" ? "text" : "password"
    );
  };

  const validate = (values) => {
    const errors = {};
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!values.otp) {
      errors.otp = "OTP is required!";
    }
    if (values.otp.length > 0 && values.otp.length !== 6) {
      errors.otp = "OTP must be 6 digits!";
    }
    if (!values.newPassword) {
      errors.newPassword = "New password is required!";
    } else if (!passwordRegex.test(values.newPassword)) {
      errors.newPassword = "Password must include: length greater than 8 characters, at least 1 uppercase, 1 numeric value and 1 special character";
    }
    if (!values.confirmPassword) {
      errors.confirmPassword = "Confirm password is required!";
    } else if (values.newPassword !== values.confirmPassword) {
      errors.confirmPassword = "Passwords do not match!";
    }
    return errors;
  };

  const submitHandle = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    const isValid = validate(formValues);
    if (Object.keys(isValid).length === 0) {
      setIsLoading(true);
      const body = {
        confirmationCode: formValues.otp,
        newPassword: formValues.newPassword,
        email: email.trim(),
      };
      try {
        const response = await userService.verifyOtp(body);
        if (response.data.status === true) {
          toast.success("Password updated successfully!");
          setTimeout(() => {
            history.push("/");
          }, 2000);
        } else if (response.data.status === false) {
          toast.error("Invalid OTP, please try again.");
        }
      } catch (error) {
        console.error("Error saving new password:", error);
        toast.error(response.data.message);
      } finally {
        setIsLoading(false);
      }
    } else {
      setFormErrors(isValid);
    }
  };
  const handleResendEmail = async () => {
    try {
      const response = await userService.generateOtp(email.trim());
      if (response.data.status === true) {
        toast.success("New OTP generated successfully!");
      } else {
        toast.error("Email does not exist!");
      }
    } catch (error) {
      toast.error("An error occurred while resending the email. Please try again.");
      console.error("Error resending email:", error);
    }
  };

      const currentYear = new Date().getFullYear();

  return (
   <>
      <ToastContainer />
      <div className="update-password-page">
        <div className="update-left-section">
          <img src={login_triangle} className="update-illustration-triangle" alt="Triangle" />
          <img src={login_ellipse} className="update-illustration-ellipse" alt="Ellipse" />
          <div className="update-left-text">
            <h2 className="update-left-heading">{t("tagline")}</h2>
            <p className="update-left-subtext">{t("subtext")}</p>
          </div>
          <p className="update-powered-by-text">Powered by <u><i>Big Entities</i></u></p>
        </div>

        <div className="update-right-section">
          <div className="update-logo-wrapper">
            <img src={logo} alt="Logo" />
          </div>

         <div className="update-form-wrapper">
          <div className="update-form-content">
            <div className="update-form-box">
              <div className="update-form-header">
                <h2>{t("forgotPassword")}</h2>
                <p>{t("enterOTPAndResetPassword")}</p>
              </div>

              <form onSubmit={submitHandle} className="update-form">
                <div className="update-form-fields">
                  <OtpInput
            value={formValues.otp}
            onChange={handleChange}
            numInputs={6}
            separator={<span style={{ width: "8px" }}></span>}
            name="otp"
            containerStyle={{ width: "400px", display: "flex", justifyContent: "space-between" }}
            inputStyle={{
              width: "60px",
              height: "40px",
              fontSize: "20px",
              textAlign: "center",
              border: "1px solid #E0E0E0",
              borderRadius: "60px",
              outline: "none",
              fontFamily: "'Poppins', sans-serif",
              color: "#1E293B",
            }}
            renderInput={(props) => <input {...props} />}
          />

        {formErrors.otp && <p className="error-text">{formErrors.otp}</p>}

        <label htmlFor="newPassword" style={{textAlign: "right"}}>{t("newPassword")}</label>
        <div className="password-input-wrapper">
          <input
            type={newPasswordType}
            name="newPassword"
            value={formValues.newPassword}
            onChange={handleChange}
          />
          <span onClick={toggleNewPassword}>
            <i className={`bi ${newPasswordType === "password" ? "bi-eye-slash" : "bi-eye"}`} />
          </span>
        </div>
        {submitted && formErrors.newPassword && (
          <p className="error-text">{formErrors.newPassword}</p>
        )}

        <label htmlFor="confirmPassword" style={{textAlign: "right"}}>{t("confirmPassword")}</label>
        <div className="password-input-wrapper">
          <input
            type={confirmPasswordType}
            name="confirmPassword"
            value={formValues.confirmPassword}
            onChange={handleChange}
          />
          <span onClick={toggleConfirmPassword}>
            <i className={`bi ${confirmPasswordType === "password" ? "bi-eye-slash" : "bi-eye"}`} />
          </span>
        </div>
        {submitted && formErrors.confirmPassword && (
          <p className="error-text">{formErrors.confirmPassword}</p>
        )}
      </div>

      <div className="update-button-group">
        <button type="submit" className="submit-btn" disabled={isLoading}>
          {isLoading ? <Loader /> : `${t("submit")}`}
        </button>
        <a href="/" className="otp-return-link">
          <span className="otp-return-icon"><ArrowLeft size={16} /></span>
          {t("returnToLogin")}
        </a>
      </div>
    </form>

    <p className="otp-resend-note">
      {t("emailNotReceivedTip")} {" "}
      <span onClick={handleResendEmail} className="otp-resend-link">{t("resendOTP")}</span>{" "}
      {t("or")} {" "}
      <a href="/forgotPassword" className="otp-resend-link">{t("tryAgain")}</a>.
          </p>
        </div>
      </div>
    </div>
          {/* <span className="update-need-help-text">Need Help?</span> */}
          <span className="update-copyright-text" style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <Copyright height={16} width={16} />
            {t("copyrightText")} {currentYear}
          </span>
        </div>
      </div>
    </>
  );
}

export default UpdatePassword;
